import { useState, useEffect, useCallback } from "react";
import { fetchStudentActivities } from "../../services/professorActivityService";

export default function useStudentActivities(studentId) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const itemsPerPage = 25;

  const loadActivities = useCallback(async () => {
    if (!studentId) return;
    try {
      setLoading(true);
      setError(null);
      const data = await fetchStudentActivities(studentId, {
        page: currentPage,
        page_size: itemsPerPage,
        ...filters,
      });

      setActivities(data.activities);
      setTotalCount(data.total_count);
      setTotalPages(data.total_pages || Math.ceil(data.total_count / itemsPerPage) || 1);
    } catch (err) {
      console.error("Error loading activities:", err);
      const msg = err.response?.data?.error || err.message || "Failed to load student activities";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }, [studentId, currentPage, filters]);

  useEffect(() => {
    loadActivities();
  }, [loadActivities]);

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  return {
    activities,
    setActivities,
    loading,
    error,
    currentPage,
    setCurrentPage,
    totalPages,
    totalCount,
    filters,
    updateFilters,
    refreshActivities: loadActivities,
    itemsPerPage,
  };
}
